module.exports = __webpack_public_path__ + "static/media/20.60e90828.jpg";